export default __webpack_public_path__ + "static/bncff-app-1-mobile-77261a0fc3f7f738be166934b53da6ad.jpg";